// extracted by mini-css-extract-plugin
export var actions = "_12-0";
export var actionsContainer = "_12-7";
export var border = "_12-1";
export var childFullHeight = "_12-f";
export var collapse = "_12-2";
export var content = "_12-a";
export var contentChild = "_12-e";
export var fullscreen = "_12-c";
export var hasLeftRadius = "_12-k";
export var headerContainer = "_12-3";
export var headerRow = "_12-5";
export var hidePadding = "_12-b";
export var navCollapsedGap = "_12-l";
export var noScrollX = "_12-m";
export var noScrollY = "_12-n";
export var noTopPadding = "_12-i";
export var optOutTopPadding = "_12-d";
export var pageMain = "_12-j";
export var pageOuter = "_12-g";
export var pagePadding = "_12-8";
export var pageScroll = "_12-9";
export var profile = "_12-o";
export var profileContainer = "_12-p";
export var profileImage = "_12-q";
export var profileMain = "_12-r";
export var profileSubtitle = "_12-t";
export var profileTitle = "_12-s";
export var showLeftPadding = "_12-h";
export var tabsPortalSlot = "_12-6";
export var tabsWrapper = "_12-4";
export var title = "_12-u";